import React, { useEffect, useRef, useState } from 'react'
import './Feedback.css'
import axios from 'axios';
import premium from "../../imgs/premium.png";
import youandher from "../../imgs/youandher.png";
import dot from "../../imgs/dot.png";
import notes from "../../imgs/notes.png";
import Viewprofile from '../Viewprofile/Viewprofile';
import { useNavigate } from 'react-router-dom';

const Feedbackmain = () => {
    const [flag, setFlag] = useState("paid");
    const [DataSource, setDataSource] = useState([]);
    const [current, setCurrent] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [input, setInput] = useState({ search: "" });
    const refprofile = useRef(null);
    const refprofileclose = useRef(null);
    const [contactdata, setContactdata] = useState({ mobno: "****************", amobno: "********************************", address: "********************************" });
    const [showconfirm, setShowconfirm] = useState(false);
    const [DataSourcepr, setDataSourcepr] = useState([]);
    const [path, setPath] = useState("photo");
    const [exist, setExist] = useState("");
    const [sr, setSr] = useState();
    const navigate = useNavigate();
    const [showfeed, setShowfeed] = useState(false);

    const openprofile = (srr) => {
        setSr(srr);
        refprofile.current.click();
        getaccountdata(srr);
        showcontacts();
    }

    const closefeed = () => {
        setShowfeed(false);
    }

    const opentoday = () => {
        navigate("/todayfeedback");
    }

    const getaccountdata = (srrr) => {
        let rawData = {
            sr: srrr,
            rootsr: localStorage.getItem("sr"),
            veri: "-",
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/getaccountdataweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            setDataSourcepr(response.data);

        }).catch(err => {
            console.log(err);
        });
    }

    

    const showcontacts = () => {
        {
            DataSourcepr.map((user, index) => (
                setContactdata({ mobno: user.mobno, amobno: user.amobno, address: user.address })
            ))
        }

    }

    const clearcontact = () => {
        refprofileclose.current.click();
        setContactdata({ mobno: "****************", amobno: "********************************", address: "********************************" });
        setShowconfirm(false);
        closefeed();
    }


    const handleChange = (event) => {
        const name = event.target.name;
        const valuecurrent = event.target.value;

        setInput(value => ({ ...value, [name]: valuecurrent }))

    }

    const sendtomadhysti = () => {

    }

    const confirmcontact = () => {


    }

    const handlephoto = () => {
        if (path === "photo") {
            setPath("photo2")
        }
        else if (path === "photo2") {
            setPath("photo3")
        }
        else if (path === "photo3") {
            setPath("photo")
        }

    }

    useEffect(() => {
        getpaidsthale("paid");
    }, [])

    const getpaidsthale = (fl) => {

        if (fl === "paid") {
            setLoading(true);
        }
        else if (fl === "free") {
            setLoading2(true);
        }
        let rawData = {
            branchcode: localStorage.getItem("brno"),
            flag: fl,
            search: input.search,

        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/getbrprofilesweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            setInput({ search: "" });
            setDataSource(response.data);

        }).catch(err => {
            console.log(err);
        })
            .finally(() => {
                setLoading(false);
                setLoading2(false);
            });

    }

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refprofile}
                data-bs-target="#exampleModaldelete"
            >
            </button>

            <div className="modal fade" id="exampleModaldelete" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '80vw' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>

                            <button type="button" className="btn-close" onClick={clearcontact} data-bs-dismiss="modal" ref={refprofileclose} aria-label="Close">
                            </button>
                        </div>
                        <div className="modal-body">
                            <Viewprofile DataSource={DataSource} DataSourcepr={DataSourcepr} handlephoto={handlephoto} path={path} contactdata={contactdata} showconfirm={showconfirm} showcontacts={showcontacts} exist={exist} sendtomadhysti={sendtomadhysti} confirmcontact={confirmcontact} user={"feedback"} showfeed={showfeed} setShowfeed={setShowfeed} />
                        </div>
                    </div>
                </div>
            </div>

            <div className='Feedbackmain'>
                <div className="Feedbackmainback">


                    <div className="options">
                        <span className='regularboldfeed'>Branch Number- {localStorage.getItem("brno")}</span>
                        <div onClick={() => getpaidsthale("paid")} style={{ marginLeft: "10px" }} className="obuttonactive">{loading ? "Please Wait.." : "Paid Profiles"}</div>
                        <div onClick={() => getpaidsthale("free")} className="obuttonactive">{loading2 ? "Please Wait.." : "Free Profiles"}</div>
                        <div onClick={opentoday} className="obuttonactive">Today List</div>

                        <div className="rowfeed">
                            <div className="rowfeed2">
                                <img className='smalllogo' src={notes} alt="" />
                                <input autoComplete='off' className="form-control feedinput" id="search" name="search" value={input.search} onChange={handleChange} placeholder='Search Profile'></input>

                                <div onClick={() => getpaidsthale("free")} className="buttonfeed">
                                    <span className="regularboldregi">Search</span>
                                </div>
                                <div className="buttonfeed">
                                    <span className="regularboldregi">Export</span>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="midbox">

                        <div className="profileboxmain">
                            {DataSource.map((user, index) => (

                                <div onClick={() => openprofile(current === 10 ? user.viewid : current === 9 ? user.visitedto : current === 8 ? user.shortsr : current === 6 ? user.visitperson : user.sr)} style={{ backgroundImage: `url(https://softtesting.in/photo/${current === 10 ? user.viewid : current === 9 ? user.visitedto : current === 8 ? user.shortsr : current === 6 ? user.visitperson : user.sr}.jpg)`, backgroundSize: '100% 100%' }} className="profile">
                                    <div className="matter">
                                        <div className="mattersub">
                                            <div className="namerow">
                                                <img className='smalllogo' src={premium} alt="" />
                                                <span className='name'>{user.name}</span>
                                                <img className='smalllogo' src={youandher} alt="" />
                                                <span style={{ fontFamily: "'Mukta', sans-serif", fontSize: '10px', color: "white" }}>You and her</span>
                                            </div>
                                            <div className="namerow">
                                                <span className='regularsmall'>{user.age} Yrs, {user.height}"</span>
                                                <img className='smalllogo2' src={dot} alt="" />
                                                <span className='regularsmall'>{user.qulidetails}</span>
                                            </div>
                                            <div className="namerow">
                                                <span className='regularsmall'>{user.bdate}</span>
                                                <img className='smalllogo2' src={dot} alt="" />
                                                <span className='regularsmall'>{user.jat}</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )
                            )}

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Feedbackmain
